<template>
  <div ref="component" class="search-empty-results">
    <Icon class="search-empty-results--icon" name="warning" />

    <Text :variant="textVariant" class="search-empty-results--text">
      Hmmm, that’s a bummer. We can’t find anything. Please try a different
      term.
    </Text>

    <SearchStartOverButton @click="$emit('startOver')" />
  </div>
</template>

<script setup>
import Icon from "@/v2/primitives/Icon/Icon.vue";
import Text from "@/v2/primitives/Text/Text.vue";
import SearchStartOverButton from "@/v2/components/Search/shared/SearchStartOverButton.vue";
import { ref, onMounted, computed, onBeforeUnmount } from "vue";

const component = ref();
const componentHeight = ref(0);

const textVariant = computed(() => {
  if (componentHeight.value < 300) {
    return "title3";
  }

  return "title1";
});

const resizeObserver = new ResizeObserver((entries) => {
  componentHeight.value = entries[0].contentRect.height;
});

onMounted(() => {
  resizeObserver.observe(component.value);
  componentHeight.value = component.value.clientHeight;
});

onBeforeUnmount(() => {
  resizeObserver.disconnect();
});

defineEmits(["startOver"]);
</script>

<style scoped lang="scss">
@import "@/v2/styles/main";

.search-empty-results {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  width: 100%;
  height: 100%;
  justify-content: center;
  gap: var(--spacing-base-md);
  padding-inline: var(--spacing-base-sm);

  @include min-width-sm {
    padding-inline: 0;
  }

  &--icon {
    color: var(--colors-primary-medium);
    font-size: 40px;
  }

  &--text {
    color: var(--colors-surface-light-50);
    text-wrap: wrap;
    text-align: center;
    width: 100%;
  }
}
</style>
